import { Dropdown, TextInput } from "pepsico-ds";
import PropTypes from "prop-types";
import "./TimeframeInputField.scss";

const UNIT_OPTIONS = [
  { id: "minutes", displayText: "minute(s)" },
  { id: "hours", displayText: "hour(s)" },
  { id: "days", displayText: "day(s)" },
];

export default function TimeframeInputField({
  value,
  unit,
  onValueChange,
  onUnitChange,
  label,
  disabled,
  required,
  errors,
}) {
  const selectedUnit = UNIT_OPTIONS.filter((o) => o.id === unit);

  return (
    <div className="timeframe-input-field">
      <div className="timeframe-input-field__controls">
        <div className="timeframe-input-field__input-slot">
          <TextInput
            label={label}
            type="number"
            value={value ?? ""}
            disabled={disabled}
            required={required}
            error={errors}
            onUpdate={(val) => onValueChange(val)}
            style={{ width: "100%" }}
          />
        </div>
        <div className="timeframe-input-field__slot">
          <Dropdown
            childList={UNIT_OPTIONS}
            selection="single"
            selectedValue={selectedUnit.length ? selectedUnit : undefined}
            setSelectedValue={(val) => {
              if (val && val.length > 0) {
                onUnitChange(val[0].id);
              }
            }}
            disabled={disabled}
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
}

TimeframeInputField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  unit: PropTypes.oneOf(["minutes", "hours", "days"]).isRequired,
  onValueChange: PropTypes.func.isRequired,
  onUnitChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  errors: PropTypes.string,
};

TimeframeInputField.defaultProps = {
  value: "",
  label: "",
  disabled: false,
  required: false,
  errors: "",
};
